var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('h6',[_vm._v("Total")])]),_vm._v(" "),_c('el-col',{staticClass:"text-right",attrs:{"span":4,"offset":12}},[_vm._v("\n    "+_vm._s(_vm._f("currency")(_vm.total))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }